import { get, post, del } from "./api";
import { err, ok, Result } from "../result";
import { ProblemDetails } from "../models/Http";
import { Language, TranslationV2 } from "../models/Translation";

export const listLanguages = async (): Promise<
  Result<ProblemDetails, Language[]>
> => {
  const response = await get("/v1/translations/languages");
  const content = await response.json();

  if (response.ok) {
    return ok(content);
  }

  return err(content.detail);
};

export const list = async (): Promise<
  Result<ProblemDetails, TranslationV2[]>
> => {
  const response = await get("/v1/translations");
  const content = await response.json();

  if (response.ok) {
    return ok(content);
  }

  return err(content.detail);
};

export const getById = async (
  id: string
): Promise<Result<ProblemDetails, TranslationV2>> => {
  const response = await get(`/v1/translations/${id}`);
  const content = await response.json();

  if (response.ok) {
    return ok(content);
  }

  return err(content.detail);
};

export const getMultipleByIds = async (
  ids: string[]
): Promise<Result<ProblemDetails, ReadonlyArray<TranslationV2>>> => {
  const response = await post(`/v1/translations/multiple`, ids);
  const content = await response.json();

  if (response.ok) {
    return ok(content);
  }

  return err(content.detail);
};

export const upsert = async (
  translation: TranslationV2
): Promise<Result<ProblemDetails, TranslationV2[]>> => {
  const response = await post(`/v1/translations/`, translation);
  const content = await response.json();

  if (response.ok) {
    return ok(content);
  }

  return err(content.detail);
};

export const remove = async (
  id: string
): Promise<Result<ProblemDetails, TranslationV2[]>> => {
  const response = await del(`/v1/translations/${id}`);
  const content = await response.json();

  if (response.ok) {
    return ok(content);
  }

  return err(content.detail);
};
